import { Box, Button, Stack } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SearchBar } from "./SearchBar";
import { sidebarMenu } from "../common/constants/commonFunction";
import { layoutStyle } from "../pages/layout-ui/style";
import { TAB_CONTENT, TAB_VALUE } from "../common/constants/popupMessage";
import { ReplacementYearCount } from "./ReplacementYearCount";
import { PopupBlock } from "./PopupBlock";
import { PageNameConstant } from "../common/constants/PageNameConstant";
import { localStorageItemNames } from "../common/constants";
import { useUser } from "../common/hooks";
import { onSortChanged } from "../common/utils/sortingColumn";
import { columnSortingMessage } from "../common/utils/columnSortingMessage";
import { SortingTextPopup } from "../components/SortingTextPopup";

export const ReplacementHeaderButton = ({
  onSearch,
  setSelectedNav,
  countYear,
  columnChange,
  movableColumnData,
  setMovableColumnData,
  movableColumn,
  updateViewMovableColumn,
  createMovableColumn,
  setColumnChange,
  gridRef,
  columnFinal,
  sortedColumn,
  sortableColumnData,
  setSortedColumn,
  setColumnFinal,
  createSortableColumn,
  updateViewSortableColumn,
  pageName,
}) => {
  const navigation = useNavigate();
  const classes = layoutStyle();
  const { popupBlock, setPopupBlock } = useUser();
  const [prevButton, setPrevButton] = useState("");
  const [nextButton, setNextButton] = useState("");
  const [openSortingPopup, setOpenSortingPopup] = useState(false);

  const handleNext = (event) => {
    if (columnChange) {
      setPopupBlock(true);
      setNextButton("/maintenance-analysis");
    } else {
      setSelectedNav(sidebarMenu.maintenance);
      navigation("/maintenance-analysis");
    }
  };
  const handleBack = () => {
    if (columnChange) {
      setPopupBlock(true);
      setPrevButton("/fleet-list");
    } else {
      setSelectedNav(sidebarMenu.fleetList);
      navigation("/fleet-list");
    }
  };

  const handleAddButton = () => {
    navigation("/new-fleetlist", {
      state: {
        tabValue: TAB_VALUE.FLEET_LIST,
        selectedContent: TAB_CONTENT.FLEET_LIST,
      },
    });
  };
  const handleMovableColumn = async () => {
    const cols = gridRef.current?.api?.getAllGridColumns();
    const colNamesIndex = cols?.map((items, index) => items?.colDef);
    if (columnFinal?.length > 0) {
      colNamesIndex?.map((items, index) => (items.sort = null));
    }
    setMovableColumnData(colNamesIndex);
    if (movableColumn?.length > 0) {
      await updateViewMovableColumn({
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: PageNameConstant.replacementSchedule,
        ColumnName: JSON.stringify(colNamesIndex),
        id: movableColumn[0]?.id,
        SortedColumn: JSON.stringify(columnFinal),
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: localStorage.getItem(localStorageItemNames.dealerId),
      });
    } else {
      await createMovableColumn({
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: PageNameConstant.replacementSchedule,
        ColumnName: JSON.stringify(colNamesIndex),
        SortedColumn: JSON.stringify(columnFinal),
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: localStorage.getItem(localStorageItemNames.dealerId),
      });
    }
    setColumnChange(false);
  };
  const onSortedColumnChange = async () => {
    await onSortChanged(
      gridRef,
      setSortedColumn,
      setColumnFinal,
      columnFinal,
      sortableColumnData,
      createSortableColumn,
      updateViewSortableColumn,
      pageName
    );
  };
  const onSortedColumnChangeAlready = () => {
    setOpenSortingPopup(true);
  };
  return (
    <Box>
      <Stack
        direction="row"
        sx={{ justifyContent: "space-between", alignItems: "center" }}
      >
        <Box className={classes.headerNameText}>Replacement Schedule</Box>
        <Box className={classes.sortingFieldText}>
          {sortableColumnData &&
          sortableColumnData?.length > 0 &&
          sortableColumnData[0]?.direction
            ? columnSortingMessage(sortableColumnData, pageName)
            : ""}
        </Box>
      </Stack>
      <Stack
        direction="row"
        sx={{ justifyContent: "space-between", alignItems: "center" }}
      >
        <ReplacementYearCount classes={classes} countYear={countYear} />
        <Box className={classes.addEditGrid}>
          {sortableColumnData?.length === 0 ? (
            <Button
              variant="outlined"
              className={classes.fleetListNewButton}
              onClick={onSortedColumnChange}
            >
              <span style={{ fontSize: 12 }}>Save Sort</span>
            </Button>
          ) : (
            <Button
              variant="outlined"
              className={classes.fleetListNewButton}
              onClick={onSortedColumnChangeAlready}
            >
              <span style={{ fontSize: 12 }}>Save Sort</span>
            </Button>
          )}
          <Button
            variant="outlined"
            className={classes.fleetListNewButton}
            onClick={handleMovableColumn}
          >
            <span style={{ fontSize: 12 }}>Save Columns</span>
          </Button>
          <Button
            variant="outlined"
            className={classes.fleetListNewButton}
            onClick={handleBack}
          >
            <span style={{ fontSize: 12 }}>Back</span>
          </Button>
          <Button
            variant="outlined"
            className={classes.fleetListNewButton}
            onClick={handleNext}
          >
            <span style={{ fontSize: 12 }}>Next</span>
          </Button>
          <Button
            variant="outlined"
            className={classes.fleetListNewButton}
            onClick={handleAddButton}
          >
            NEW
          </Button>
          <SearchBar onSearch={onSearch} />
        </Box>
        {popupBlock && (
          <PopupBlock
            open={popupBlock}
            setOpen={() => setPopupBlock(false)}
            navigationRouteNext={nextButton}
            navigationRoutePrev={prevButton}
            selectedNavStyle={
              nextButton ? sidebarMenu.maintenance : sidebarMenu.fleetList
            }
            columnChangeData={movableColumnData}
            pageName={PageNameConstant.replacementSchedule}
          />
        )}
        {openSortingPopup && (
          <SortingTextPopup
            open={openSortingPopup}
            setOpen={setOpenSortingPopup}
            gridRef={gridRef}
            setSortedColumn={setSortedColumn}
            setColumnFinal={setColumnFinal}
            columnFinal={columnFinal}
            sortableColumnData={sortableColumnData}
            createSortableColumn={createSortableColumn}
            updateViewSortableColumn={updateViewSortableColumn}
            pageName={PageNameConstant.replacementSchedule}
          />
        )}
      </Stack>
    </Box>
  );
};
